import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type AccountWithoutSubscription = {
    accountId: string
    name: string
    email: string
    phone: string
    city: string | null
    state: string | null
    isDisabled: boolean
    createdDate: string
}

export const getAccountsWithoutSubscriptions = (): Promise<AccountWithoutSubscription[]> => {
    return api.get('/v2/subscription-reports/accounts-without-subscriptions')
}

export const getAccountsWithoutSubscriptionsQueryOptions = () => {
    return queryOptions({
        queryKey: ['subscription-reports', 'accounts-without-subscriptions'],
        queryFn: () => getAccountsWithoutSubscriptions(),
    })
}

type UseAccountsWithoutSubscriptionsOptions = {
    queryConfig?: QueryConfig<typeof getAccountsWithoutSubscriptions>
}

export const useAccountsWithoutSubscriptions = ({ queryConfig }: UseAccountsWithoutSubscriptionsOptions = {}) => {
    return useQuery({
        ...getAccountsWithoutSubscriptionsQueryOptions(),
        ...queryConfig,
    })
}

